export enum ENTERPRISE_ORDER_STATUS {
  ONGOING = 'ONGOING',
  COMPLETED = 'COMPLETED',
}

export const ENTERPRISE_ORDER_STATUS_LABEL = {
  [ENTERPRISE_ORDER_STATUS.ONGOING]: '進行中',
  [ENTERPRISE_ORDER_STATUS.COMPLETED]: '已完成',
};
